<div class="ts-rail-card">
    <h3 class="ts-rail-card-title">Trending Topics</h3>

    <div class="ts-trend-list">
        <a *ngFor="let topic of trendingTopics"
           class="ts-trend-row"
           routerLink="/search"
           [queryParams]="{ q: topic.Hashtag }">
            <p class="ts-trend-tag">#{{ topic.Hashtag }}</p>
            <p class="ts-trend-count">{{ topic.TotalEngagement | number }} posts</p>
        </a>
    </div>
</div>
